export interface CreateContactItem {
  comment: string;
  profileId?: string;
  role: ContactUserRole;
  email?: string;
  firstName?: string;
  lastName?: string;
}

export enum ContactUserRole {
  Anonymous,
  Service,
  EnterpriseUser,
  EnterpriseAdmin
}
